import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const fetchAppModelsPageTE = <E = CF.API.ApiError>(
  {
    userId,
    appId,
    params,
  }: {
    userId: string;
    appId: string;
    params?: {
      page?: string | number;
      perPage?: string | number;
      modelTypeId?: string;
    };
  },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Models.ListModelsResponse> => {
  const fieldNames = {
    page: 'page',
    perPage: 'per_page',
    modelTypeId: 'model_type_id',
  };

  const queryParams: Record<string, string> = Object.keys(fieldNames).reduce((acc: Record<string, string>, fieldName) => {
    if (params && (params as Record<string, string | number>)[fieldName] !== undefined) {
      const key: string = (fieldNames as Record<string, string>)[fieldName];
      const value: string | number = (params as Record<string, string | number>)[fieldName];
      acc[key] = value.toString();
    }
    return acc;
  }, {});

  const searchParams = new URLSearchParams(queryParams);

  return fetchTE<CF.API.Models.ListModelsResponse, E>(
    {
      path: `/api/_api/v2/users/${userId}/apps/${appId}/models?${searchParams.toString()}`,
      method: 'GET',
    },
    onRejected,
  );
};
